import { Injectable } from '@angular/core';

import { Logger } from '~/core/logger.service';

import { ToggleService } from './toggle.service';

@Injectable({
  providedIn: 'root',
})
export class DummyService extends ToggleService {
  constructor(private readonly logger: Logger) {
    super();
  }

  protected updateContext(field: string, value: string): void {
    this.logger.info("Dummy toggle context change but i don't care tbh", {
      field,
      value,
    });
  }

  public getVariant(
    toggleName: string,
    defaultValue: string | object
  ): string | object {
    return defaultValue;
  }

  public isEnabled(toggleName: string): boolean {
    return true;
  }
}
